import { render, staticRenderFns } from "./RelatedGame.vue?vue&type=template&id=b05c914e&scoped=true"
import script from "./RelatedGame.vue?vue&type=script&lang=ts"
export * from "./RelatedGame.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./RelatedGame.vue?vue&type=style&index=0&id=b05c914e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b05c914e",
  "0014bdbc"
  
)

export default component.exports